<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { useJoakimStore } from '@/stores/useJoakimStore'

const { t } = useI18n()
const { umsokn, onLoaded } = useUmsokn()
const joakimStore = useJoakimStore()

const props = defineProps<{ disable?: boolean }>()

interface Rettindi {
  checked: boolean
  sidastGreitt: string
  sjodur: string
  vefslod: string
}

const onnurRettindi = ref<Rettindi[]>([])

const otherRights = computed<Rettindi[]>(() =>
  umsokn.value?.sjodir?.rettindiHjaOdrumSjodum ?? []
)

defineExpose({ validate: () => true })

onLoaded(async () => {
  const rights = await joakimStore.getOnnurRettindi()
  onnurRettindi.value = rights?.rettindiHjaOdrumSjodum ?? []
})
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('lifeyri_umsokn_step4_header1') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>{{ t('lifeyri_umsokn_step4_checkbox_label_sendtootherlifeyris') }}</p>
        </v-col>
      </v-row>

      <!-- Show checkboxes when rights exist -->
    <v-row v-if="otherRights.length">
        <v-col>
            <div v-for="(item, idx) in otherRights" :key="item.sjodur ?? idx">
            <v-checkbox
                v-model="item.checked"
                :label="item.sjodur"
                :readonly="props.disable"
                hide-details
                density="comfortable"
            />

            </div>
        </v-col>
    </v-row>

      <v-row>
        <v-col>
          <span class="forms__notice forms__notice-bold">
            {{ t('lifeyri_umsokn_header_fyrirvari') }}
          </span>
          <p class="forms__notice">{{ t('lifeyri_umsokn_fyrirvari') }}</p>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
